<template lang="pug">
  div.signin-container
   .d-flex.flex-column
     // Back button - positioned absolutely in top left
     .back-button-container
       el-button(circle @click="goToHome" class="back-button")
         i.el-icon-arrow-left

     div.d-flex.mb-2.mx-auto.spot-logo-container.align-items-center(@click="goToHome")
        img(src="@/assets/images/logos/logo_circle.png").w-40.h-40
        img(
        src="@/assets/images/logos/logo-text.png"
          srcset="@/assets/images/logos/text_logo_white.png"
        ).h-30
     div.d-flex.flex-column.min-vh-100.signin-form-container
        h1.mb-0.mx-auto Welcome Back
        .fs-14.lh-2.mx-auto
          span.fc-gray Don't have an account?
          router-link(:to="`/auth/web/signup${queryString}`")
            span.el-button.el-button--text.mb-1 &nbsp; Get Started
        div.px-20.py-4.c-auth__form
          el-form(
            ref="refForm"
            :rules="rules"
            :model="item"
            status-icon
            label-position="top"
          ).signin-form-elements
            .alert.alert-danger(v-if="error")
             | phone or password incorrect

            el-form-item(prop="phone" label="Phone" class="signin-label")
              el-input(
                v-model="item.phone"
                type="tel"
                placeholder="(123) 456-7890"
                v-mask="'(###) ###-####'"
              ).sign-in-inputs

            el-form-item( prop="password" label="Password" class="signin-label")
              el-input(v-model="item.password" type="password").sign-in-inputs

            .py-4.text-center
              el-button(round type="success"
                @click="validateForm" v-loading="loading").sign-in-button Login

            .p-4.text-center
                el-button(link @click="gotoForgotPassword").ms-auto
                  span.fc-gray Forgot your password?
  </template>

<script>
import {
  defineComponent, reactive, ref, onMounted,
} from 'vue';
import { mask } from 'vue-the-mask';
import { checkUserExists, signIn } from '@/graphs/gql';
import { phone } from '@/data/rules';
import shared from '../../../shared';
// import gqlRequest from '../dashboard/gql-request';

// Cache implementation
export default defineComponent({
  name: 'WebAppSignIn',
  directives: { mask },
  setup() {
    const {
      route,
      router,
      store,
      makeGraphRequest,
    } = shared();
    const item = reactive({
      phone: '',
      password: '',
    });
    const loading = ref(false);
    const refForm = ref(null);
    const error = ref(false);
    const { stickerId, redirect } = route.query;
    const queryString = ref('');

    const rules = {
      phone,
      password: [
        {
          required: true,
          message: 'Password is required',
        },
      ],
    };

    function checkAuth() {
      if (store.getters['users/isMeSignedIn']) {
        if (route.path !== '/web/') {
          // router.push('web/dashboard');
        }
      }
    }

    async function submitForm() {
      try {
        loading.value = true;
        error.value = false;
        const checkUser = await makeGraphRequest('query', checkUserExists, { phone: item.phone, email: '', userId: '' }, null);
        if (checkUser.data != null) {
          const { phone } = checkUser.data.checkUserExists;
          const response = await makeGraphRequest(
            'mutation',
            signIn,
            { input: { phone, password: item.password } },
            null,
          );
          store.commit('users/SET_IS_ME_SIGNED_IN', true);
          store.commit('users/SET_ME', response.data.signIn);

          store.dispatch('users/autoSelectFirstOrganization');

          // Redirect to the intended destination
          if (redirect) {
            router.replace(redirect);
          } else if (stickerId !== undefined) {
            router.push(`/web/sticker/${stickerId}`);
          } else {
            router.push('/web/');
          }
        } else {
          error.value = true;
        }
      } catch (err) {
        error.value = true;
      } finally {
        loading.value = false;
      }
    }

    function validateForm() {
      refForm.value.validate((valid) => {
        if (valid) return submitForm();
        return false;
      });
    }

    function gotoForgotPassword() {
      router.push('/auth/forgot-password?returnTo=web');
    }

    // New logo click function
    function goToHome() {
      router.push('/');
    }

    onMounted(() => {
      queryString.value = location?.search ?? '';
      store.commit('shared/SET_MAIN_MENU_COLLAPSE', false);
      checkAuth();
    });

    return {
      // data (static)
      refForm,
      rules,

      // data (dynamic)
      loading,
      error,
      item,
      queryString,
      validateForm,
      gotoForgotPassword,
      goToHome,
    };
  },
});
</script>
  <style>
  .signin-container {
      background-color: #4ccbbf;
      background-image: linear-gradient(to right, #1EBEAF, #57D3C7);
      position: relative;
  }

  .back-button-container {
      position: absolute;
      top: 20px;
      left: 20px;
      z-index: 10;
  }

  .back-button {
      background-color: rgba(255, 255, 255, 0.2) !important;
      border: 1px solid rgba(255, 255, 255, 0.3) !important;
      color: white !important;
      width: 40px;
      height: 40px;
      backdrop-filter: blur(10px);
      transition: all 0.3s ease;
  }

  .back-button:hover {
      background-color: rgba(255, 255, 255, 0.3) !important;
      transform: scale(1.05);
  }

  .spot-logo-container {
      padding: 50px 0px;
      cursor: pointer;
      transition: transform 0.2s ease;
  }

  .spot-logo-container:hover {
      transform: scale(1.02);
  }
  .spot-logo-container > img{
      margin: 0px 6px;
  }
  .signin-form-container {
      background-color: #fff;
      border-radius: 30px 30px 0px 0px;
      padding: 40px 0px;
      box-shadow: 0px -24px 0px -15px #ffffff80;
  }

  .signin-label {
    width: 100%;
  }

  .c-auth__form {
    max-width: 560px;
    width: 100%;
    padding: 0 20px;
    margin: 0 auto;
  }
  </style>
